<template>
    <div
        class="vrm-avatar"
        :class="{
            'vrm-avatar--initials': !imageReady,
            'vrm-avatar--admin': hasFullControl,
            'vrm-avatar--technician': isTechnician,
        }"
    >
        <img v-show="imageReady" :src="avatarUrl" @load="onImageLoaded" />
        <template v-if="!imageReady">
            {{ initials }}
        </template>
        <div
            v-if="shouldShowIcon"
            :class="{
                'vrm-avatar__icon vrm-avatar__icon--blue': hasFullControl,
                'vrm-avatar__icon vrm-avatar__icon--green': isTechnician,
            }"
        >
            <span
                :class="{
                    'sg-vrm-icon_148_star_border_12px': hasFullControl,
                    'sg-vrm-icon_124_wrench-16px': isTechnician,
                }"
            ></span>
        </div>
    </div>
</template>
<style scoped lang="scss"></style>
<script>
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { AngularDirective } from '@/vue/decorators/angular-interop';
import { vrmInstallationAccessLevel } from '@/vue/store/modules/installation-access-level';

@Component
@AngularDirective('vrm-avatar')
export default class VrmAvatar extends Vue {
    @Prop({ type: Object, default: null })
    user;
    @Prop({ type: String, default: 'fullControl' })
    adminKey;

    imageReady = false;

    get avatarUrl() {
        return this.user && this.user.avatar_url;
    }

    @Watch('avatarUrl')
    onImageUrlChanged() {
        this.imageReady = false;
    }

    get hasFullControl() {
        return (
            (this.user && this.adminKey && this.user[this.adminKey]) ||
            (this.user && this.user.accessLevel === vrmInstallationAccessLevel.FULL_CONTROL)
        );
    }

    get initials() {
        if (!this.user || !this.user.name) {
            return '';
        }
        const name = this.user.name.trim();
        const nameWords = name.split(' ');
        const firstName = nameWords[0];
        if (nameWords.length === 1) {
            return firstName[0];
        } else {
            const lastName = nameWords[nameWords.length - 1];
            return firstName[0] + lastName[0];
        }
    }

    get isTechnician() {
        return this.user && this.user.accessLevel === vrmInstallationAccessLevel.TECHNICIAN;
    }

    get shouldShowIcon() {
        return this.hasFullControl || this.isTechnician;
    }

    onImageLoaded() {
        this.imageReady = true;
    }
}
</script>
